import React, { useState, useEffect, useContext, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  CardTitle,
  ModalBody,
  ModalFooter,
  FormGroup,
} from 'reactstrap'
import { isEmpty, get, head } from 'lodash'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'
import ProductCard from '../../../components/Common/ProductCard'
import { getImagesOfProduct, getUrlOfDefaultProductImage } from '../../../helpers/utils'

const FormPage = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading } = generalContext

  const inputCodigoRef = useRef(null)

  const [products, setProducts] = useState([])
  const [removeModal, setRemoveModal] = useState(false)
  const [temporalProduct, setTemporalProduct] = useState({})
  const [taLoading, setTaLoading] = useState(false)
  const [productsTypeAhead, setProductsTypeAhead] = useState([])
  const [productSearched, setProductSearched] = useState({})
  const [selectProductModal, setSelectProductModal] = useState(false)

  const storeId = get(props, 'match.params.storeId', false)

  const toggleRemoveModal = () => setRemoveModal(!removeModal)
  const toggleSelectProductModal = () => setSelectProductModal(!selectProductModal)

  useEffect(() => {
    setProducts(props.products)
  }, [props]) // eslint-disable-line

  const handleSubmit = async (e) => {
    e.preventDefault()
    props.history.push(`/mi-tienda/${storeId}/compartir`)
  }

  const addProduct = async () => {
    setLoading(true)
    toggleSelectProductModal()
    try {
      const data = {
        storeId: storeId,
        productId: productSearched.id,
      }
      const response = await ApiService.addProductToStore(data)
      if (response.data.success) {
        toastr.success(response.data.message, '¡Éxito!')
        setProductSearched({})
        inputCodigoRef.current.clear()
        await props.fetchStoreById(props.store.id)
      }
    } catch(e) {
      toastr.error(`${e.response.data.message}`, 'Error')
    } finally {
      setLoading(false)
    }
  }

  const removeProductConfirm = (e, item) => {
    e.preventDefault()
    setTemporalProduct(item)
    toggleRemoveModal()
  }

  const removeProduct = async () => {
    try {
      toggleRemoveModal()
      setLoading(true)
      const response = await ApiService.removeProductOfStore(temporalProduct.id)
      if (response.data.success) {
        toastr.success(response.data.message, '¡Éxito!')
        await props.fetchStoreById(props.store.id)
      }
    } catch(e) {
      toastr.error(`${e.response.data.message}`, 'Error')
    } finally {
      setLoading(false)
    }
  }

  const searchProductsBySupplierAndFilter = async (filter) => {
    try {
      setLoading(true)
      setTaLoading(true)
      const textToSearch = filter.replace(/%/gi, '').trim()
      if (!isEmpty(textToSearch)) {
        const response = await ApiService.getProductsByKeyword(textToSearch.toUpperCase())
        if (response.data.success) {
          if (!isEmpty(response.data.data)) {
            setProductsTypeAhead(response.data.data)
          } else {
            setProductsTypeAhead([])
          }
        }
      }
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
      setTaLoading(false)
    }
  }

  const selectProductSearched = (productArray) => {
    setProductsTypeAhead([])
    const product = head(productArray)
    setProductSearched(product)
    toggleSelectProductModal()
    inputCodigoRef.current.clear()
  }

  const validateIfCardIsDisabled = () => {
    if (!isEmpty(productSearched)) {
      return productSearched.status.codeName !== 'ACTIVO' ||
        parseFloat(productSearched.wholeSalePrice) === 0
    }
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="flex-fill">Agregar Productos</CardTitle>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <AsyncTypeahead
                  filterBy={() => true}
                  id="codigo"
                  isLoading={taLoading}
                  labelKey="supplierCode"
                  ref={inputCodigoRef}
                  minLength={3}
                  onChange={selectProductSearched}
                  onSearch={searchProductsBySupplierAndFilter}
                  options={productsTypeAhead}
                  placeholder="Busca tus productos..."
                  searchText="Buscando..."
                  promptText="Buscando..."
                  emptyLabel="Producto no encontrado"
                  useCache={false}
                  renderMenuItemChildren={(i, props) => (
                    <React.Fragment>
                      <img
                        alt={i.name}
                        src={
                          !isEmpty(i.gallery) ? head(i.gallery).fileName : getUrlOfDefaultProductImage()
                        }
                        style={{
                          height: '24px',
                          marginRight: '10px',
                          width: '24px',
                        }}
                      />
                      <span>{i.supplierCode} - {i.name}</span>
                    </React.Fragment>
                  )}
                />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Row>
        <Col xs={12}>
          <Card>
            <CardBody>
              <CardTitle className="flex-fill">Eliminar Productos</CardTitle>
              <Row>
                {!isEmpty(products) && products.map(
                  (item, key) => (
                    <Col key={key} sm={3} style={{ textAlign: 'center', marginBottom: '15px' }}>
                      <ProductCard
                        photos={getImagesOfProduct(item.product.gallery)}
                        code={`${item.product.supplierCode ? `Código ${item.product.supplierCode}` : ''}`}
                        price={`${item.product.wholeSalePrice || 0}`}
                        productName={item.product.name}
                        supplierName={item.product.supplier.nombreComercial}
                        showVariants={false}
                        showAddProductButton
                        actionAddProductButton={(e) => removeProductConfirm(e, item)}
                        textAddProductButton="Eliminar"
                        styleAddProductButton="btn-danger"
                      />
                    </Col>
                  )
                )}
              </Row>
            </CardBody>
          </Card>
          <Card style={{textAlign: 'right'}}>
            <CardBody>
              <Button
                onClick={() => { window.history.go(-1) }}
                className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
              >
                Cancelar
              </Button>
              <Button
                color="primary"
                onClick={handleSubmit}
                className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
              >
                Publicar mi tienda
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div>
        <Modal isOpen={removeModal} toggle={toggleRemoveModal}>
          <ModalHeader toggle={toggleRemoveModal}>Eliminar producto</ModalHeader>
          <ModalBody>
            ¿Está seguro que desea eliminar el producto de su tienda?
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleRemoveModal}>Cancelar</Button>{' '}
            <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={() => removeProduct()}>Eliminar producto</Button>
          </ModalFooter>
        </Modal>
      </div>
      <div>
        <Modal
          isOpen={selectProductModal}
          toggle={toggleSelectProductModal}
          style={{ backgroundColor: 'white' }}
        >
          <ModalHeader
            toggle={toggleSelectProductModal}
            style={{ backgroundColor: 'white' }}
          >
            {!isEmpty(productSearched) && productSearched.name}
          </ModalHeader>
          <ModalBody style={{ backgroundColor: 'white' }}>
            <ProductCard
              photos={getImagesOfProduct(!isEmpty(productSearched.gallery) ? productSearched.gallery : [])}
              code={`${productSearched.supplierCode ? `Código ${productSearched.supplierCode}` : ''}`}
              price={`${productSearched.wholeSalePrice || 0}`}
              showVariants={false}
              showFooterOptions={false}
              showAddProductButton
              actionAddProductButton={addProduct}
              textAddProductButton={'Agregar a mi tienda'}
              disabled={validateIfCardIsDisabled()}
            />
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default withRouter(FormPage)
